import React, { useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { GlobalContext } from '../contexts/GlobalContext';
import SnackbarContent from '@material-ui/core/SnackbarContent';


const columns = [
    { id: 'code', label: 'Code', minWidth: 150 },
    { id: 'display', label: 'Display', minWidth: 170 },
];

function createDataRows(tags) {
    if (tags) {
        return tags.map((tag) => createData(tag));
    }
    return {};
}

function createData(tag) {
    const code = tag.code;
    const display = tag.display;
    const system = tag.system;

    return {
        code,
        display,
        system
    };
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#383838',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export default function ValueSetDialogTags(props) {
    const classes = useStyles();
    const dataRows = createDataRows(props.meta.tag);
    const dataRowsCount = dataRows.length;
    const globals = useContext(GlobalContext)

    useEffect(() => {
        if (props) {
            // console.log('globals', globals);
            // console.log('props', props.resourceType);
        }
    });

    function displayTable() {
        if (dataRowsCount > 0)
            return (
                <Paper className={classes.root}>
                    <TableContainer className="csTable__container">
                        <Table stickyHeader className="csTable_tableHeader" size="small" aria-label="sticky table">
                            <TableHead className="csTable_tableHeader">
                                <TableRow>
                                    {columns.map((column) => (
                                        <StyledTableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.label}
                                        </StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataRows
                                    .filter(item => item.system === globals.tagSystem)
                                    .map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                <TableCell key={columns[0].id} align={columns[0].align}>
                                                    {row[columns[0].id]}
                                                </TableCell>

                                                <TableCell key={columns[1].id} align={columns[1].align}>
                                                    {row[columns[1].id]}
                                                </TableCell>

                                                {/* <TableCell key={columns[2].id} align={columns[2].align}>
                                            {row[columns[2].id]}
                                        </TableCell> */}

                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )

        return <SnackbarContent
            message={'No meta data tags have been set for this ValueSet'}
        />
    }

    return (
        displayTable()
    );
}
